export default "__VITE_ASSET__qfKt62qL__"